import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowLeftIcon from '../icons/ArrowLeftIcon';

const ProviderProfileNavigation: React.FC = () => {
  const navigate = useNavigate();

  return (
    <nav className="bg-white border-t border-b border-[#eaeaea]">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
        <div className="flex items-center">
          <button
            onClick={() => navigate('/dashboard')}
            className="flex-shrink-0 flex items-center gap-2 px-2 sm:px-4 py-3 text-sm font-['Ovo'] text-[#1f1f1f] uppercase hover:bg-[#1f1f1f] hover:text-white transition-colors"
          >
            <ArrowLeftIcon />
          </button>
          {/* Horizontal scrollable nav on mobile */}
          <div className="flex-1 overflow-x-auto scrollbar-hide">
            <div className="flex justify-center min-w-max">
              <button
                onClick={() => navigate('/dashboard')}
                className="px-4 sm:px-8 py-3 text-xs sm:text-sm font-['Ovo'] text-[#1f1f1f] uppercase whitespace-nowrap hover:bg-[#1f1f1f] hover:text-white transition-colors"
              >
                HOME
              </button>
              <button
                onClick={() => navigate('/endorsements')}
                className="px-4 sm:px-8 py-3 text-xs sm:text-sm font-['Ovo'] text-[#1f1f1f] uppercase whitespace-nowrap hover:bg-[#1f1f1f] hover:text-white transition-colors"
              >
                ENDORSEMENTS
              </button>
              <button
                onClick={() => navigate('/whats-hot')}
                className="px-4 sm:px-8 py-3 text-xs sm:text-sm font-['Ovo'] text-[#1f1f1f] uppercase whitespace-nowrap hover:bg-[#1f1f1f] hover:text-white transition-colors"
              >
                WHAT'S HOT!
              </button>
            </div>
          </div>
          <div className="hidden sm:block w-[66px]"></div>
        </div>
      </div>
    </nav>
  );
};

export default ProviderProfileNavigation;
